import React from 'react';
import ReactMarkdown from "react-markdown";

interface CenteredMessageProps {
    message: string;
}

const CenteredMessage: React.FC<CenteredMessageProps> = ({ message }) => (
    <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '95vh',
        fontSize: '18px',
        textAlign: 'center',
        padding: '20px'
    }}>
        <ReactMarkdown>{message}</ReactMarkdown>
    </div>
);

export default CenteredMessage;
